import client from '../_helper/client'
import { stringify as querystring } from '../_helper/query'

export const disbusementService = {
    calc
}

function calc (request) {
    let url = '/api/v2/disbursement?' + querystring(request)
    if (request.format === 'csv' || request.format === 'xlsx') {
        window.open(url, '_blank')
        request.format = 'json'
        url = '/api/v2/disbursement?' + querystring(request)
    }
    return client.get(url)
}
